import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@reapit/elements/core/button'
import { PageLayout } from '@reapit/elements/core/page-layout'
import {
  PageNotFoundContainer,
  PageNotFoundDescription,
  PageNotFoundMessagesContainer,
  PageNotFoundTitle,
} from './style'

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()

  const handleBackToHome = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    navigate('/')
  }

  return (
    <PageLayout id="not-found-page" scroll="self" backgroundColour="--colour-fill-neutral-lightest">
      <PageLayout.BodyRegion>
        <PageNotFoundContainer>
          <PageNotFoundMessagesContainer>
            <PageNotFoundTitle>Page Not Found</PageNotFoundTitle>
            <PageNotFoundDescription>
              The page you&apos;re looking for might have been removed or is temporarily unavailable.
            </PageNotFoundDescription>
          </PageNotFoundMessagesContainer>
          <Button variant="primary" size="medium" onClick={handleBackToHome} type="button">
            Back to Home
          </Button>
        </PageNotFoundContainer>
      </PageLayout.BodyRegion>
    </PageLayout>
  )
}

export default NotFoundPage
